module.exports = __webpack_public_path__ + "static/media/certyfikat-14.a7401b33.png";